import React, { Fragment } from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';

interface Theme {
   primaryBlueLight: string;
   primaryBlueDark: string;
   secondaryBlueLight: string;
   secondaryBlueDark: string;
   almostBlack: string;
   primaryWhite: string;
   secondaryWhite: string;
   primaryGrey: string;
   primaryRed: string;
   secondaryRed: string;
   primaryGreen: string;
   secondaryGreen: string;
   disabled: string;
   boxShadow: string;
}

export const theme: Theme = {
   primaryBlueLight: '#303f5e',
   primaryBlueDark: '#151d2e',
   secondaryBlueLight: '#36a6df',
   secondaryBlueDark: '#1a82b8',
   almostBlack: 'hsl(0, 0%, 18%)',
   primaryWhite: '#FFF',
   secondaryWhite: '#eee',
   primaryGrey: '#aaa',
   primaryRed: 'hsl(0, 59%, 41%)',
   secondaryRed: 'hsl(0, 61%, 50%)',
   primaryGreen: 'hsl(116, 43%, 38%)',
   secondaryGreen: 'hsl(113, 47%, 62%)',
   disabled: '#515d75',
   boxShadow: '0 12px 24px 0 rgba(0, 0, 0, 0.09)',
};

const ThemeWrapper: React.FC<{ children: any }> = ({ children }): JSX.Element => (
   <Fragment>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
      <GlobalStyle />
   </Fragment>
);

const GlobalStyle = createGlobalStyle`
   html {
      width: 100%;
      height: 100%;
      border: solid 1px transparent;
      font-family: 'mono';
   }
   *, *:before, *:after {
      box-sizing: inherit;
   }
   body {
      height: 100%;
      width: 100%;
      padding: 0;
      margin: 0;
      line-height: 2;
   }

   #root {
      height: 100%;
      width: 100%;
   }
   
   p {
   margin-top: 15px;
   font-size: 1em;
   line-height: 1.5;
   }

   a {
      color: ${theme.primaryBlueLight};
      text-decoration: none;
   }

   a:hover {
      color: ${theme.primaryBlueDark};
   }
`;

export default ThemeWrapper;
